import { useEffect, useState } from "react";

interface UseComparisonViewTrackingProps {
  createView: () => Promise<string>;
  patchView: (viewId: string, sortHistory: string[]) => Promise<void>;
  createViewDisabled?: boolean;
}

interface UseComparisonViewTrackingReturn {
  onSort: (criteriaId: string) => void;
  viewId: string | null;
}

export const useComparisonViewTracking = ({
  createView,
  patchView,
  createViewDisabled
}: UseComparisonViewTrackingProps): UseComparisonViewTrackingReturn => {
  const [viewId, setViewId] = useState<string | null>(null);
  const [sortHistory, setSortHistory] = useState<string[]>([]);

  const onSort = (criteriaId: string) => {
    setSortHistory([...sortHistory, criteriaId]);
  };

  useEffect(() => {
    if (createViewDisabled) return;

    const _createView = async () => {
      const _viewId = await createView();

      setViewId(_viewId);
    };

    _createView();
  }, [createViewDisabled]);

  useEffect(() => {
    if (viewId) {
      patchView(viewId, sortHistory);
    }
  }, [sortHistory]);

  return {
    onSort,
    viewId,
  };
};
